import React from 'react';
import SwilDocuments from './SwilDocuments';
export default function Outstanding({ customer }) { return <SwilDocuments kind="outstanding" customer={customer} />; }
